import type { FunctionComponent } from "react"

import classnames from "classnames"

import styles from "./Icon.module.css"

const iconPaths = {
  AfterArrow: (
    <path d="M14.7071 5.29289C14.3166 4.90237 13.6834 4.90237 13.2929 5.29289C12.9024 5.68342 12.9024 6.31658 13.2929 6.70711L17.5858 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H17.5858L13.2929 17.2929C12.9024 17.6834 12.9024 18.3166 13.2929 18.7071C13.6834 19.0976 14.3166 19.0976 14.7071 18.7071L20.7071 12.7071C21.0976 12.3166 21.0976 11.6834 20.7071 11.2929L14.7071 5.29289Z" />
  ),
  ArrowDown: (
    <path d="M17.7071 9.79289C18.0976 10.1834 18.0976 10.8166 17.7071 11.2071L12.7071 16.2071C12.3166 16.5976 11.6834 16.5976 11.2929 16.2071L6.29289 11.2071C5.90237 10.8166 5.90237 10.1834 6.29289 9.79289C6.68342 9.40237 7.31658 9.40237 7.70711 9.79289L12 14.0858L16.2929 9.79289C16.6834 9.40237 17.3166 9.40237 17.7071 9.79289Z" />
  ),
  BurgerMenu: (
    <path d="M2 17a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z" />
  ),
  Cross: (
    <path d="M7.20711 5.79291C6.81658 5.40238 6.18342 5.40238 5.79289 5.79291C5.40237 6.18343 5.40237 6.8166 5.79289 7.20712L10.5858 12.0001L5.79301 16.7929C5.40249 17.1834 5.40249 17.8166 5.79301 18.2071C6.18353 18.5976 6.8167 18.5976 7.20722 18.2071L12.0001 13.4143L16.7929 18.2071C17.1834 18.5976 17.8166 18.5976 18.2071 18.2071C18.5976 17.8166 18.5976 17.1834 18.2071 16.7929L13.4143 12.0001L18.2072 7.20712C18.5977 6.8166 18.5977 6.18343 18.2072 5.79291C17.8167 5.40238 17.1835 5.40238 16.793 5.79291L12.0001 10.5859L7.20711 5.79291Z" />
  ),
  Profile: (
    <>
      <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z" />
      <path d="M12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM5.898 18.615A8.965 8.965 0 0 0 12 21a8.965 8.965 0 0 0 6.102-2.385c-.443-.34-1.05-.667-1.817-.939C15.1 17.256 13.62 17 12 17s-3.1.256-4.285.676c-.767.272-1.374.599-1.817.94Zm1.15-2.824C8.47 15.287 10.178 15 12 15c1.82 0 3.528.287 4.953.79 1.403.498 2.625 1.241 3.354 2.225a1 1 0 0 1-.053 1.256A10.976 10.976 0 0 1 12 23c-3.288 0-6.24-1.444-8.254-3.729a1 1 0 0 1-.053-1.256c.729-.984 1.951-1.727 3.354-2.224Z" />
    </>
  ),
}

export type IconProps = {
  className?: string
  isBig?: boolean
  name: keyof typeof iconPaths
}

export const Icon: FunctionComponent<IconProps> = ({ name, isBig, className }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classnames(styles["hdr-Icon"], { [styles["hdr-Icon--isBig"]]: isBig }, className)}
  >
    {iconPaths[name]}
  </svg>
)
